<template>
  <v-card class="card">
    <v-toolbar dense flat>
      <v-toolbar-title>{{ meter.name }}<br /> </v-toolbar-title>
    </v-toolbar>
    <div class="menu">
      <v-btn
        v-if="needResetButton && !$vuetify.breakpoint.mdAndDown"
        icon
        v-on:click="resetZoom"
      >
        <v-icon>mdi-magnify-remove-outline</v-icon>
      </v-btn>
    </div>
    <v-col class="py-1" v-if="needGroupBreadcrumbs">
      <GroupsItem
        :item="meter"
        :slot-data="{
          name: '_groups',
          to: 'analysis',
          divider: ' > ',
          linkParams: { project: 'project_id' },
          linkQuery: { group_id: 'id' }
        }"
        class="groups-link"
      ></GroupsItem>
    </v-col>
    <v-divider></v-divider>
    <v-tabs v-model="tabIndex" class="tabs">
      <template v-for="(item, i) in tabs">
        <v-tab :key="i">
          {{ $t(`${item.title}`) }}
        </v-tab>
      </template>
    </v-tabs>
    <v-divider></v-divider>
    <v-tabs-items v-model="tabIndex">
      <template v-for="(item, i) in tabs">
        <v-tab-item :key="`tab-item-${i}-${item.title}`">
          <component
            v-bind:is="item.component"
            :meter="meter"
            :meter-units="meterUnits"
            :project_id="project_id"
            :options="prepareOptions"
            :ref="item.component"
          ></component>
        </v-tab-item>
      </template>
    </v-tabs-items>
  </v-card>
</template>

<script>
import MeterChart from "./metersTabs/MeterChart";
import MeterCounts from "./metersTabs/MeterCounts";
import MeterDetails from "./metersTabs/MeterDetails";
import ExportRecordsMeterUnit from "../projects/metering/meter-units/ExportRecordsMeterUnit";
import GroupsItem from "../common/tables/items/GroupsItem";
import moment from "moment-timezone";
export default {
  name: "MeterAnalysis",
  components: {
    MeterChart,
    MeterCounts,
    MeterDetails,
    ExportRecordsMeterUnit,
    GroupsItem
  },
  props: {
    meter_id: {
      type: String
    },
    options: {
      type: Object
    },
    project_id: {
      type: String
    },
    needGroupBreadcrumbs: {
      type: Boolean,
      default: false
    },
    needResetButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      meter: {},
      prepareOptions: {},
      meterUnits: [],
      tabIndex: 0,
      tabs: [
        {
          component: "MeterChart",
          title: "analysis.meter-chart"
        },
        {
          component: "MeterCounts",
          title: "analysis.meter-counts"
        },
        {
          component: "MeterDetails",
          title: "analysis.meter-details"
        },
        {
          component: "ExportRecordsMeterUnit",
          title: "buttons.export"
        }
      ]
    };
  },
  methods: {
    getItem() {
      let project_id = this.project_id;
      this.meter = {};
      this.meter_id &&
        this.project_id &&
        this.$store.dispatch("projectMeteringStore/meterStore/get", {
          id: this.meter_id,
          project_id: this.project_id,
          onSuccess: res => {
            res._groups = res._group
              ? [
                  ...(res._group._ancestors || []),
                  { ...res._group, project_id: project_id || "-" }
                ]
              : [];
            this.meter = { ...res };
          }
        });

      this.meter_id &&
        this.$store.dispatch("projectMeteringStore/meterUnitStore/getList", {
          params: {
            project_id: this.project_id,
            limit: -1,
            filters: {
              meter: this.meter_id
            }
          },
          onSuccess: res => {
            this.meterUnits = res.list || [];
          }
        });
    },
    resetZoom() {
      this.$refs.MeterChart[0].resetZoom();
    },
    prepareOptionsHandler() {
      let options = { ...this.options };
      if (!options.date_from && options.date_to) {
        let format = "YYYY-MM-DD";
        options.date_from = moment(options.date_to)
          .subtract(3, "year")
          .format(format);
      }
      this.prepareOptions = options;
    }
  },
  watch: {
    meter_id() {
      this.getItem();
    },
    options: {
      handler: function() {
        this.prepareOptionsHandler();
      },
      deep: true
    }
  },
  mounted() {
    this.prepareOptionsHandler();
    this.getItem();
  }
};
</script>

<style lang="scss" scoped>
.tabs::v-deep .v-tab:not(.v-tab--active) {
  color: rgba(0, 0, 0, 0.87) !important ;
}
.small {
  font-size: 70%;
}
.groups-link::v-deep {
  span {
    color: rgba(0, 0, 0, 0.65);
    cursor: default;
  }
  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}
.card {
  position: relative;
}
.menu {
  position: absolute;
  right: 0;
  top: 6px;
  z-index: 1;
}
</style>
